import { useEffect, useState } from "react";
import "./EachJob.css";
import { CiLocationOn } from "react-icons/ci";
import DashboardModal from "../dashboardModal/DashboardModal";
import { config } from "../../config";
import CustomButton from "../customButton/CustomButton";
import TimeSheetIcon from "../icon/TimeSheetIcon";
import StarIcon from "../icon/StarIcon";
import { _currency_format } from "../../utils";
import { useNavigate } from "react-router-dom";
import useIsMobile from "../../hook/useIsMobile";
import ReactStars from "react-rating-stars-component";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import { useRatingJobMutation } from "../../store/query/applicants";
import { toast } from "react-toastify";

const EachJob = ({ job, status, fillTimeSheetJob, loading }) => {
  const [showTimesheetModal, setShowTimesheetModal] = useState(false);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [statusState, setStatusState] = useState("");
  const [statusColor, setStatusColor] = useState("#007BFF");
  const { job_info } = job;
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const logo =
    job?.logo?.length > 0
      ? `${config.getPublicImages}/${job?.logo}`
      : `https://www.generationsforpeace.org/wp-content/uploads/2018/03/empty.jpg`;

  const btnStyled = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    padding: "8px 8px",
    gap: "10px",
  };

  useEffect(() => {
    if (status === 1) {
      setStatusState("APPLIED");
      setStatusColor("#FFA500");
    } else if (status === 2) {
      setStatusState("SHORTLISTED");
      setStatusColor("#00BFFF");
    } else if (status === 3) {
      setStatusState("DECLINED");
      setStatusColor("#DC3545");
    } else if (status === 4) {
      setStatusState("ONGOING");
      setStatusColor("#9B870C");
    } else if (status === 5) {
      setStatusState("COMPLETED");
      setStatusColor("#008000");
    } else if (status === 6) {
      setStatusState("SAVED");
      setStatusColor("#A9A9A9");
    }
  }, [status]);

  return (
    <>
      <div className="job-box">
        <div className="flex-head">
          <img src={logo} alt="job-img" />

          <div>
            <h3>{job_info?.title}</h3>
            <div className="div-locate">
              <CiLocationOn className="job-location-icon" />
              <span className="job-location-text">
                {job.city},{job.state}
              </span>
            </div>
          </div>
        </div>

        <div className="second-section">
          <div className="flex-second">
            <h3>
              {job_info?.title.length > 12
                ? job_info?.title?.slice(0, 15) + "..."
                : job_info?.title}
            </h3>
            <span>N{job_info?.hourly_rate}/hr</span>
          </div>
          <div className="flex-second-dec">
            <p>
              {job_info?.description?.length > 100
                ? job_info?.description?.slice(0, 100) + "..."
                : job_info?.description}
            </p>
          </div>
        </div>

        <div className="third-section">
          {(status === 2 || status === 4) && (
            <div>
              <CustomButton
                onClick={() => {
                  setShowTimesheetModal(!showTimesheetModal);
                }}
                title={
                  <>
                    {job?.timesheet_status === 1 ? (
                      <div style={btnStyled}>
                        View Sheet <TimeSheetIcon />
                      </div>
                    ) : (
                      <div style={btnStyled}>
                        FILL SHEET <TimeSheetIcon />
                      </div>
                    )}
                  </>
                }
                customStyles={{
                  width: "100%",
                  borderRadius: "5px",
                  height: 35,
                  fontSize: "12px",
                }}
              />
            </div>
          )}
          {(status === 1 || status === 6 || status === 2 || status === 4) && (
            <div style={{ width: "80px" }}>
              <CustomButton
                variant="outline"
                onClick={() => {
                  navigate(`/joblistings/${job?.job_id}`);
                }}
                title={<div style={btnStyled}>VIEW</div>}
                customStyles={{
                  width: "100%",
                  borderRadius: "5px",
                  height: 35,
                  fontSize: "12px",
                  fontWeight: 600,
                }}
              />
            </div>
          )}

          {status === 5 && (
            <div className="left">
              <CustomButton
                variant="outline"
                onClick={() => {
                  setShowReviewModal(!showReviewModal);
                }}
                title={
                  <div style={btnStyled}>
                    REVIEW <StarIcon />
                  </div>
                }
                customStyles={{
                  width: "100%",
                  borderRadius: "5px",
                  height: 35,
                  fontSize: "12px",
                }}
              />
            </div>
          )}
        </div>

        <div
          className="status"
          style={{
            backgroundColor: statusColor,
          }}
        >
          <span>{statusState}</span>
        </div>
      </div>

      <DashboardModal
        //onClose={() => setShowTimesheetModal(false)}
        isOpen={showTimesheetModal}
        customStyle={{
          width: isMobile ? "95%" : "80%",
        }}
      >
        <FillTimeSheet
          job={job}
          onClose={() => setShowTimesheetModal(false)}
          loading={loading}
          fillTimeSheetJob={fillTimeSheetJob}
        />
      </DashboardModal>

      <DashboardModal isOpen={showReviewModal}>
        <ReviewModal onClose={() => setShowReviewModal(false)} job={job} />
      </DashboardModal>
    </>
  );
};

export default EachJob;

const FillTimeSheet = ({ job, onClose, fillTimeSheetJob, loading }) => {
  const [selectedSheet, setSelectedSheet] = useState([]);

  const handleRemoveSheet = (id) => {
    const newSelectedSheet = selectedSheet.filter((i) => i.timesheet_id !== id);
    setSelectedSheet(newSelectedSheet);
  };

  const timesheet =
    job?.timesheet_status !== 1 ? job.timesheet : job?.filled_timesheet;

  return (
    <div className="timesheet-con">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div></div>
        <h3>Timesheet</h3>

        <span onClick={onClose} style={{ fontSize: "20px", fontWeight: 800 }}>
          X
        </span>
      </div>

      <div className="timesheet-headings">
        {job?.timesheet_status !== 1 && <span>#</span>}
        <span>Start Date</span>
        <span>End Date</span>
        <span>Start Time</span>
        <span>End Time</span>
        <span>Hours</span>
        <span>Charges</span>
      </div>
      <div className="timesheet-result-box">
        {timesheet?.map((item, i) => (
          <div key={i} className="single-candidate">
            {job?.timesheet_status !== 1 && (
              <div className="single">
                <span className="mobile-time">#</span>
                <input
                  type="checkbox"
                  id="mark"
                  name="mark"
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedSheet((prev) => [
                        ...prev,
                        { timesheet_id: item.id, status: 1 },
                      ]);
                    } else {
                      handleRemoveSheet(item.id);
                    }
                  }}
                />
              </div>
            )}
            <div className="single">
              <span className="mobile-time">Start Date:</span>
              <p>{item.start_date}</p>
            </div>
            <div className="single">
              <span className="mobile-time">End Date:</span>
              <p>{item.end_date}</p>
            </div>
            <div className="single">
              <span className="mobile-time">Start Time:</span>
              <p>{item.start_time}</p>
            </div>
            <div className="single">
              <span className="mobile-time">End Time:</span>
              <p>{item.end_time}</p>
            </div>
            <div className="single">
              <span className="mobile-time">Hours:</span>
              <p>{item.hour}</p>
            </div>
            <div className="single">
              <span className="mobile-time">Charges:</span>
              <p>
                {_currency_format(
                  Number(item.hour * job?.job_info?.hourly_rate),
                  "NGN",
                )}
              </p>
            </div>
          </div>
        ))}
      </div>

      {job?.timesheet_status !== 1 && (
        <div className="timesheet-footer">
          <div className="timesheet-btn">
            <CustomButton
              onClick={() => {
                fillTimeSheetJob({
                  job_id: job.job_info.id,
                  timesheet: [...selectedSheet],
                });
              }}
              loading={loading}
              title="Submit"
              disable={selectedSheet.length < 1}
              customStyles={{
                width: "100%",
                borderRadius: "5px",
                height: 35,
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

const ReviewModal = ({ onClose, job }) => {
  //console.log("job", job);
  const [ratingJob, { isLoading }] = useRatingJobMutation();
  const [comment, setComment] = useState("");
  const [listItems, setListItems] = useState([
    {
      id: "supportive_staff",
      title: "Supportive Staff",
      count: 0,
    },
    {
      id: "workload_balance",
      title: "Workload Balance",
      count: 0,
    },
    {
      id: "resource",
      title: "Resource/Work tools Availability",
      count: 0,
    },
    {
      id: "onboarding",
      title: "Onboarding/Handover",
      count: 0,
    },
    {
      id: "work_environment",
      title: "Work Environment",
      count: 0,
    },
  ]);

  const ratingChanged = (newRating, id) => {
    const updatedItems = listItems.map((item) =>
      item.id === id ? { ...item, count: newRating } : item,
    );
    setListItems(updatedItems);
  };

  const handleSubmit = async () => {
    const ratingPayload = listItems.reduce((acc, item) => {
      acc[item.id] = item.count;
      return acc;
    }, {});
    let payload = {
      type: "individual",
      job_id: job.job_id,
      poster_id: job.poster_id,
      poster_account_type: job.poster_account_type,
      comment: comment,
      ...ratingPayload,
    };

    const res = await ratingJob({
      ...payload,
    });

    //console.log("res", res);

    if (res.data.status) {
      toast.success(
        res.data.message ?? "Rating Job was completed Successfully",
      );
      onClose();
      //await manageRefetch();
    } else {
      toast.error("Failed to rate job");
    }
  };

  const hasZeroRating = listItems.some((item) => item.count === 0);

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        {/* Header */}
        <div className="modal-header">
          <MdOutlineKeyboardBackspace
            onClick={onClose}
            size={24}
            className=""
          />

          <h3 className="modal-title">Rate this Job</h3>
        </div>

        {/* Job Info */}
        <div className="job-info">
          <h3 className="job-title">Locum Nurse Shift</h3>
          <p className="job-subtitle">
            Lagos University Teaching Hospital <br />
            12 Aug, 8am–4pm
          </p>
        </div>

        {/* Rating */}
        <div className="rating-section">
          <p className="section-label">Rate your experience?</p>

          <div className="list-rating">
            {listItems.map(({ id, title }) => (
              <div key={id} className="each-list">
                <h4>{title}</h4>

                <div style={{}}>
                  <ReactStars
                    count={5}
                    onChange={(e) => ratingChanged(e, id)}
                    size={25}
                    activeColor="#ffd700"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Comment */}
        <div className="comment-section">
          <p className="section-label">Add a comment:</p>
          <textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Share more about your experience (optional)"
            className="comment-box"
          />
        </div>

        {/* Submit */}
        <div className="submit-section">
          <CustomButton
            customStyles={{
              marginTop: "10px",
              width: "100%",
              height: "40px",
              fontSize: "16px",
              borderRadius: "5px",
            }}
            title="Submit Rating"
            onClick={handleSubmit}
            disable={isLoading || hasZeroRating}
            loading={isLoading}
          />
        </div>
      </div>
    </div>
  );
};
